var AuthorizedRoute = require('../mixins/authorized-route')
var Scope = require('../utils/scope')

module.exports = Em.Route.extend(AuthorizedRoute, {

    userOrganizations: Em.inject.service(),

    organization: Em.computed.alias('userOrganizations.activeOrganization'),

    isSourceZervant: function() {
        var organization = this.get('organization')
        return organization.get('isSourceZervant')
    }.property('organization'),

    scopes: function() {
        return this.get('isSourceZervant') ? [] : [Scope.OfferRead]
    }.property('organization'),

    model: function() {
        return this.modelFor('quote')
    },

    setupController: function(controller, model) {
        if (this.get('isSourceZervant')) {
            return
        }

        controller.set('model', model)
        controller.loadHtml()
        controller.activate()
    }
})
